import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function Login() {
  const { user, signInWithGoogle, signInAsGuest, loading, firebaseEnabled } =
    useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from?.pathname || '/';
  const [error, setError] = useState(null);

  // If Firebase resolves a redirect-flow login asynchronously, route away.
  useEffect(() => {
    if (user) navigate(from, { replace: true });
  }, [user, from, navigate]);

  const handleGoogle = async () => {
    setError(null);
    try {
      const result = await signInWithGoogle();
      if (result) navigate(from, { replace: true });
      // If null was returned, the user closed the popup or a redirect is in flight.
    } catch (err) {
      setError(err.message || 'Sign-in failed');
    }
  };

  const handleGuest = () => {
    signInAsGuest();
    navigate(from, { replace: true });
  };

  return (
    <div className="login-screen">
      <div className="login-hero">
        <img
          src="/icons/logo-mark.png"
          alt="Pub Golf"
          className="brand-logo brand-logo-xl"
        />
        <div className="subtitle">A distinguished game for distinguished drinkers</div>
      </div>

      <div className="actions">
        {error && (
          <div className="login-error">{error}</div>
        )}
        {!firebaseEnabled && (
          <div className="login-error">
            Google sign-in not configured — add VITE_FIREBASE_API_KEY to .env
          </div>
        )}
        <button
          className="btn btn-block btn-lg google-btn"
          onClick={handleGoogle}
          disabled={loading || !firebaseEnabled}
        >
          <span style={{ fontWeight: 700 }}>G</span>
          {loading ? 'Signing in…' : 'Continue with Google'}
        </button>

        <button className="guest-link" onClick={handleGuest}>
          or <strong>Continue as guest</strong>
          <br />
          <span style={{ fontSize: '0.7rem' }}>
            Data won't sync across devices
          </span>
        </button>

        <div className="terms">
          By continuing you agree to our Terms of Service and Privacy Policy.
        </div>
      </div>
    </div>
  );
}
